import loadingGif from '../../../Assets/loadingGIF.gif';

const Loading = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '82vh',
            flexDirection:"column",
            textAlign: 'center',
            background:'white'
        }}>
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/loadingGIF.gif' alt="Loading..." style={{ height: "60px", width: "60px" }} />
            <p style={{color:"red", fontSize:"13px"}}>All services at fingertips</p>
        </div>
        
    );
};

export default Loading;